import firebase from "firebase"
import "firebase/firestore"
import "firebase/analytics"
  
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
    apiKey: "AIzaSyATG_PNTP7Q4mpdc7yUNWnlVTBpzVwsydg",
    authDomain: "sitcom-517e9.firebaseapp.com",
    projectId: "sitcom-517e9",
    storageBucket: "sitcom-517e9.appspot.com",
    messagingSenderId: "427586034933",
    appId: "1:427586034933:web:4f2755a2ebb2e866a539bc",
    measurementId: "G-ME5F2Y0HEP"
};
// Initialize Firebase
// firebase.initializeApp();

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

// it's recommend to test if analytics is supported
// export const analytics = () => firebase.analytics.isSupported().then((isSupported) => {
//     if (isSupported) {
//       return firebase.analytics();
//     }
// })

export const analytics = firebase.analytics();
export const db = firebase.firestore()


export default firebase